import { render, staticRenderFns } from "./ParametrizacaoMultiplosProdutosDialog.vue?vue&type=template&id=2dc662ed&scoped=true"
import script from "./ParametrizacaoMultiplosProdutosDialog.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoMultiplosProdutosDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc662ed",
  null
  
)

export default component.exports